<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 16H9V14H5V10H7V14H9V19H5V16ZM19 8H15V10H19V14H17V10H15V5H19V8Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
